import React, { Component } from "react"
import { NamespacesConsumer as I18n } from "react-i18next"
import { NotificationManage } from "../../components/NotificationManage"
import validator from "validator"
import { connect } from "react-redux"
import { compose } from "redux"
import { API, graphqlOperation } from "aws-amplify"
import axios from "axios"
import "../../css/Login.css"

//component
import { trackLogin } from "../../graphql/mutation"
import ObjectGenerator from "../Function/CreateUserObjectGenerator"
import Restorepassword from "./Restorepassword"
import * as user_actions from "../../actions/action_user"
import { waitForInit, waitForGBInit } from "../Function/Login.function"
import {
	handleClickGM,
	handleClickFB,
	handleClickLN
} from "../Function/Register.function"
import LoginForm from "./LoginForm"
import { handlelocalstorageSet } from "./PostMessage"

//material ui
import PropTypes from "prop-types"
import withStyles from "@material-ui/core/styles/withStyles"
import { LoginStyle } from "../Style/LoginStyle"

class Login extends Component {
	constructor(props) {
		super(props)
		this.state = {
			email: "",
			password: "",
			isLoading: false,
			erroremail: false,
			OpenDialogRestorepassword: false,
			userAttributes: {}
		}
	}

	async componentDidMount() {
		await waitForInit()
		await waitForGBInit()
	}
	UNSAFE_componentWillReceiveProps() {
		if (!this.props.Open) {
			this.setState({
				email: "",
				password: "",
				isLoading: false,
				erroremail: false,
				OpenDialogRestorepassword: false,
				userAttributes: {}
			})
		}
	}
	handleChange = (event) => {
		if (event.target.id === "email") {
			this.setState({
				[event.target.id]: event.target.value
					.toLowerCase()
					.trim()
					.replace(/\s+/g, "")
			})
		} else if (event.target.id === "password") {
			this.setState({
				[event.target.id]: event.target.value.replace(/\s+/g, "")
			})
		} else {
			this.setState({
				[event.target.id]: event.target.value
			})
		}

		if (event.target.id === "email") {
			if (event.target.value.length === 0) {
				this.setState({ erroremail: false })
			} else {
				if (
					validator.isEmail(
						event.target.value.toLowerCase().trim().replace(/\s+/g, "")
					)
				) {
					this.setState({ erroremail: false })
				} else {
					this.setState({ erroremail: true })
				}
			}
		}
	}

	validateForm = () => {
		if (
			!validator.isEmail(this.state.email) ||
			this.state.email.length === 0 ||
			this.state.password.length === 0
		) {
			return false
		}
		return true
	}
	handleClickOpenNewPasswordReq = (e) => {
		this.setState({ OpenDialogRestorepassword: true })
	}

	handleClickCloseNewPasswordReq = () => {
		this.setState({ OpenDialogRestorepassword: false })
	}
	handleConfirmationSubmit = async (event, t) => {
		event.preventDefault()
		let { email, password } = this.state
		if (localStorage.getItem("UsedCookie") === "true") {
			this.props
				.login_local(email, password, t)
				.then(async (res) => {
					if (res.value === "NEW_PASSWORD_REQUIRED") {
						await this.props.userobject()
						this.handleClickOpenNewPasswordReq()
					} else {
						await this.props.userobject()
						this.props
							.get_user(
								res.value.result.Credentials.data.IdentityId,
								this.props.user
							)
							.then(async (responses) => {
								if (Object.keys(responses.value).length === 0) {
									axios
										.get("https://extreme-ip-lookup.com/json/")
										.then(async (data) => {
											await this.props.create_user(
												ObjectGenerator({ email, ...res, data }, "EMAIL")
											)
										})
										.catch((err) => {})

									await this.props.get_user(
										res.value.result.Credentials.data.IdentityId,
										this.props.user
									)
								}
								axios
									.get("https://extreme-ip-lookup.com/json/")
									.then(async (data) => {
										await API.graphql(
											graphqlOperation(
												trackLogin(
													JSON.stringify(data.data).replace(/"/g, '\\"')
												)
											)
										)
									})
									.catch((err) => {})
								await this.props.update_latest_login()
								handlelocalstorageSet()
								NotificationManage(
									"success",
									`Welcome ${res.value.result.cognitoUser.attributes.given_name} ${res.value.result.cognitoUser.attributes.family_name}`,
									"Login success"
								)
							})
							.catch((err) => {})
					}
					this.props.handleClickClose()
				})
				.catch((err) => {})
		} else {
			NotificationManage(
				"info",
				`${t("NotificationManager.Login.You")}`,
				`${t("NotificationManager.status.info")}`
			)
		}
	}

	render() {
		const {
			classes,
			handleClickClose,
			Open,
			handleClickOpen,
			finishgm,
			finishfb,
			finishln,
			finishlocal,
			login_gm,
			login_fb,
			login_ln,
			create_user,
			get_user,
			update_latest_login
		} = this.props
		const {
			erroremail,
			email,
			password,
			OpenDialogRestorepassword
		} = this.state
		return (
			<I18n>
				{(t) => {
					return (
						<div>
							<LoginForm
								t={t}
								classes={classes}
								handleClickClose={handleClickClose}
								Open={Open}
								handleClickOpen={handleClickOpen}
								OpenDialogRestorepassword={OpenDialogRestorepassword}
								finishlocal={finishlocal}
								erroremail={erroremail}
								email={email}
								password={password}
								handleChange={this.handleChange}
								validateForm={this.validateForm}
								handleConfirmationSubmit={this.handleConfirmationSubmit}
								finishgm={finishgm}
								finishfb={finishfb}
								finishln={finishln}
								login_gm={login_gm}
								login_fb={login_fb}
								login_ln={login_ln}
								handleClickGM={handleClickGM}
								handleClickFB={handleClickFB}
								handleClickLN={handleClickLN}
								create_user={create_user}
								get_user={get_user}
								update_latest_login={update_latest_login}
								history={this.props.history}
							/>
							<Restorepassword
								Open={OpenDialogRestorepassword}
								handleClickCloseNewPasswordReq={
									this.handleClickCloseNewPasswordReq
								}
								email={email}
								password={password}
							/>
						</div>
					)
				}}
			</I18n>
		)
	}
}

Login.propTypes = {
	classes: PropTypes.object.isRequired
}

function mapStateToProps(reduxState) {
	return {
		finishgm: reduxState.UserReducer.finishgm,
		finishfb: reduxState.UserReducer.finishfb,
		finishln: reduxState.UserReducer.finishln,
		finishlocal: reduxState.UserReducer.finishlocal
	}
}
const mapDispatchToProps = function (dispatch) {
	return {
		login_fb: (data) => dispatch(user_actions.login_fb(data)),
		login_gm: (data) => dispatch(user_actions.login_gm(data)),
		login_ln: (data) => dispatch(user_actions.login_ln(data)),
		login_local: (email, password, t) =>
			dispatch(user_actions.login_local(email, password, t)),
		userobject: () => dispatch(user_actions.userobject()),
		create_user: (data) => dispatch(user_actions.create_user(data)),
		get_user: (user_id, user) => dispatch(user_actions.get_user(user_id, user)),
		update_latest_login: (data) =>
			dispatch(user_actions.update_latest_login(data))
	}
}
export default compose(
	withStyles(LoginStyle),
	connect(mapStateToProps, mapDispatchToProps)
)(Login)
